<template>
  <div>
    <div v-if="loading" class="loading">
      <MoonLoader></MoonLoader>
    </div>
    <div v-else>
      <div v-if="this.$route.query.sortBy" class="row">
        <div class="col">
          <p>Filtered by color: {{ this.$route.query.sortBy }}</p>
        </div>
      </div>
      <div v-if="answers.length > 0" class="row">
        <div class="col-md-6 col-xl-3" v-for="answer in answers" :key="answer.id">
          <DashboardElementPrimary :answer="answer" :company="company"></DashboardElementPrimary>
        </div>
      </div>
      <div v-else class="row text-center">
        <div class="col">
          <h3>
            Here you will find your saved questions from the Questionnaire under the Education and Policies category.
            <br />
          </h3>
          <span class="text-font">
            To add them to the Dashboard go to
            <router-link
              :to="{
                path: '/manage_answers/' + company.company_id,
                query: {
                  company: company,
                  selectedQuestionType: question_type,
                  selectedFilters: [getCategoryForFilters()],
                },
              }"
              >Questionnaire</router-link
            >
            and click on the button:
          </span>
          <br /><br />
          <p-button outline icon type="primary" class="questions-list__question-button">
            <i class="fas fa-star"></i>
          </p-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import CategoryDashboardElement from '@/controllers/Category/CategoryDashboardElement';
import DashboardElementPrimary from '@/components/Dashboard/DashboardElementPrimary';
import StatsCard from '@/components/Cards/StatsCard';
import DefineValueClass from '@/controllers/Class/DefineValueClass';
import GroupingController from '@/controllers/Helpers/GroupingController';
import QuestionTypeController from '@/controllers/QuestionType/QuestionTypeController';
export default {
  name: 'PoliciesPage',
  components: { DashboardElementPrimary, MoonLoader, StatsCard },
  data() {
    return {
      categories: null,
      category: null,
      chosenCategory: null,
      loading: false,
      answers: null,
      company: null,
      question_type: null,
    };
  },
  async created() {
    this.loading = true;
    await this.getCategories();
    await this.setCategory();
    await this.getCategoryDashboardElements();
    await this.getCompany();
    this.question_type = await this.getQuestionType();
    this.loading = false;
  },
  methods: {
    async getCategories() {
      this.categories = await this.$store.dispatch('retrieveCategories');
    },
    async setCategory() {
      this.category = this.categories.find((category) => {
        return category.name === 'policies';
      });
    },
    async getCategoryDashboardElements() {
      this.answers = await CategoryDashboardElement.show(this.category.id);
      if (this.$route.query.sortBy)
        this.answers = GroupingController.filterAnswers(this.answers, this.$route.query.sortBy);
      if (this.$route.query.find) DefineValueClass.highlightAnswer(this.answers, this.$route.query.find);
    },
    async getCompany() {
      this.company = this.$store.getters.company;
    },
    async getQuestionType() {
      let questionTypes = await QuestionTypeController.index();
      let vm = this;
      return questionTypes.find(function (questionType) {
        return questionType.name === 'SignUp';
      });
    },
    getCategoryForFilters() {
      return { id: this.category.id, name: 'education and policies' };
    },
  },
};
</script>

<style scoped></style>
